const url = {
  root: 'https://booking-server-9cpa.onrender.com'
}

export default url